import React, {useState} from "react";
import {Formik,ErrorMessage,Field,Form} from "formik";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { resetPassword } from "../../validations/authValidations";
import { resetPasswordAction } from "../../stores/actions/authActions";
import { useDispatch } from "react-redux";

export default function ResetPassword(){

    const dispatch = useDispatch();

    const [formBtn,setFormBtn]=useState('Reset Password');
    const [disabled,setDisabled]=useState(false);

    const navigate = useNavigate();
    let location = useLocation();
    let searchParams = new URLSearchParams(location.search);
    let token = searchParams.get('t');
    let email = searchParams.get('e');

    const initialValues = {
        email: email,
        token: token,
        password: '',
        password_confirmation: ''
    };

    const resetPasswordSubmit=async(values)=>{
        console.log(values);
        setDisabled(true);
        setFormBtn("Please wait ....");
        dispatch(resetPasswordAction(values)).then(response=>{
            if(response.meta.requestStatus=="fulfilled"){
                setDisabled(false);
                setFormBtn("Reset Password");
                navigate("/");
            }else{
                setDisabled(false);
                setFormBtn("Reset Password");
            }
        });
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12" style={{background: 'url(/assets/images/header_bg.png) left top repeat-x', textAlign: 'center', paddingTop: '210px'}}>
                    <img src='/assets/images/logo-img_small.png' width="100"/>
                    <h4>Reset your password</h4>
                    <p>Enter your new password below</p>

                    <div className="offset-sm-4 col-sm-4" style={{padding: '0 100px 310px 100px'}}>
                        <Formik initialValues={initialValues} onSubmit={(values,{setSubmitting})=>{
                            resetPasswordSubmit(values);
                        }}
                        >
                            <Form>
                                <div className='form-group mb-3'>
                                    {/* <label htmlFor="" >Password</label><span className='text-danger'></span> */}
                                    <Field type="password" name="password" id="password" className='form-control' placeholder='Password' />
                                    <ErrorMessage name='password' component="p" className='errorMessage'/>
                                </div>
                                <div className='form-group mb-3'>
                                    {/* <label htmlFor="" >Password</label><span className='text-danger'></span> */}
                                    <Field type="password" name="password_confirmation" id="confirm-password" className='form-control' placeholder='Confirm Password' />
                                    <ErrorMessage name='password_confirmation' component="p" className='errorMessage'/>
                                </div>
                                <div className='form-group'>
                                    <button className='login-btn' disabled={disabled} type="submit">{formBtn}</button>
                                </div>
                            </Form>
                        </Formik>
                    </div>

                </div>
            </div>
        </>
    )

}